<companyid-content-wrapper
    classNames="py-40px w-full justify-beetween mob:px-5 mob:flex-col mob:gap-y-40px tab:px-5 tab:flex-col tab:gap-y-40px">
    <div class="flex flex-col gap-15px w-full text-medium-regular text-primary-text-color">
        <span class="text-h3-bold text-dark">{{ title() }}</span>
        <span>{{ lastUpdated }}</span>
        <span>{{ subtitle() }} <ng-content /></span>
    </div>
    <companyid-social-media isDark />
</companyid-content-wrapper>
